export async function ensureMinimumOperationTime(
  startTime: number,
  minDuration: number = 1000,
): Promise<void> {
  const elapsedTime = Date.now() - startTime

  if (elapsedTime < minDuration) {
    await new Promise((resolve) => setTimeout(resolve, minDuration - elapsedTime))
  }
}
